import { faker } from '@faker-js/faker';
import { generateFromEnum } from '@ingenico/api-sdk-core/mocks';
import {
  enumCatalogEntityType,
  enumCatalogShareStatus,
  type CatalogShareRecipientApi,
  type CatalogShareResourceReadBffApi,
  type CatalogShareResourceTargetApi,
  type CatalogShareStatusMetadataBffApi,
  type CatalogShareStatusMetadataRevokedBffApi,
  type CreatorApi,
  type EnumCatalogEntityTypeApi,
  type EnumCatalogShareStatusApi,
  type StatusDetailGenericApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import { HttpResponse } from 'msw';
import { generateErrorWithPlaceholdersApi } from './bff';

function generateCatalogShareRecipientApi(optional?: Partial<CatalogShareRecipientApi>): CatalogShareRecipientApi {
  const email = faker.internet.email();

  return {
    email,
    normalizedEmail: email.toLowerCase(),
    ...optional,
  };
}

function generateCatalogShareResourceTargetApi(
  opt?: Partial<CatalogShareResourceTargetApi>,
): CatalogShareResourceTargetApi {
  return {
    id: faker.string.uuid(),
    type: generateFromEnum(enumCatalogEntityType) as EnumCatalogEntityTypeApi,
    versionMetadata: {
      parentName: faker.commerce.product(),
      versionNumber: faker.system.semver(),
    },
    ...opt,
  };
}

export function generateCreatorApi(opt?: Partial<CreatorApi>): CreatorApi {
  return {
    id: faker.string.uuid(),
    name: `${faker.person.firstName()} ${faker.person.lastName()}`,
    ...opt,
  };
}
export function generateCatalogShareStatusMetadataRevokedBffApi(
  opt?: Partial<CatalogShareStatusMetadataRevokedBffApi>,
): CatalogShareStatusMetadataRevokedBffApi {
  return {
    revokedBy: generateCreatorApi(),
    revokedAt: faker.date.past(),
    ...opt,
  };
}
export function generateCatalogShareStatusMetadataBffApi(
  opt?: Partial<CatalogShareStatusMetadataBffApi>,
): Required<CatalogShareStatusMetadataBffApi> {
  return {
    revoked: generateCatalogShareStatusMetadataRevokedBffApi(),
    active: {
      activatedAt: faker.date.past(),
    },
    expired: {
      expiredAt: faker.date.past(),
    },
    failed: {
      failedAt: faker.date.past(),
    },
    type: generateFromEnum(enumCatalogShareStatus) as EnumCatalogShareStatusApi,
    ...opt,
  };
}
export function generateStatusDetailGenericApi(
  opt?: Partial<StatusDetailGenericApi>,
): Required<StatusDetailGenericApi> {
  return {
    code: 'CSH-ERR-006',
    message: 'generic message',
    placeholders: [],
    ...opt,
  };
}

export function generateCatalogShareResourceReadBffV2Api(
  optional?: Partial<CatalogShareResourceReadBffApi>,
): CatalogShareResourceReadBffApi {
  const status = generateFromEnum(enumCatalogShareStatus) as EnumCatalogShareStatusApi;

  return {
    id: faker.string.uuid(),
    createdAt: faker.date.past(),
    emailRetentionExpirationDate: faker.date.future(),
    maxUsageCount: faker.number.int({ min: 1, max: 50 }),
    recipients: faker.helpers.multiple(generateCatalogShareRecipientApi, {
      count: faker.number.int({ min: 5, max: 50 }),
    }),
    status,
    statusDetail: generateStatusDetailGenericApi(),
    target: generateCatalogShareResourceTargetApi(),
    createdBy: generateCreatorApi(),
    statusMetadata: generateCatalogShareStatusMetadataBffApi({ type: status }),
    ...optional,
  };
}

export function getCatalogShareByIdV2ResponseMock() {
  return HttpResponse.json<CatalogShareResourceReadBffApi>(
    generateCatalogShareResourceReadBffV2Api({
      statusMetadata: {
        failed: {
          failedAt: faker.date.past(),
        },
        type: generateFromEnum(enumCatalogShareStatus) as EnumCatalogShareStatusApi,
      },
    }),
  );
}
export function triggerCatalogShareRevokeV2ResponseMock() {
  return HttpResponse.json(
    generateErrorWithPlaceholdersApi({
      type: 'CSH-ERR-006',
    }),
    { status: 404 },
  );
}
